/*
 * OATHERA brand assets for the auth/admin UI (controlplane-auth task 11.1, DESIGN-DECISION-3).
 *
 * The real assets staged at `apps/ui/src/assets/brand/` are imported as URLs: Vite emits each file
 * with a content-hashed name under `/assets/` and this module exports the resolved, same-origin URL
 * string. Components reference these exports (e.g. `<img src={oMark} …>`) instead of hard-coding a
 * path, so the hashing/cache-busting is handled by the build and the assets load from 'self' under
 * the BFF's `img-src 'self' data:` CSP.
 *
 *   oMark             — `oathera-o-black.svg`, the O mark. Used for the login card badge (where the
 *                       AgentDNA reference uses its shield) and the browser favicon.
 *   logo              — `oathera-logo.png`, the full wordmark+mark. Used in the nav / header.
 *   controlplaneLogo  — `oathera-controlplane-logo.svg`, the multi-color control-plane mark. Used
 *                       ONLY on the control plane's login brand panel (its natural navy/blue/grey
 *                       colors are kept — it is NOT inverted like the mono assets above).
 */

// `?url` makes Vite return the emitted asset URL even for SVG (rather than inlining it as a string).
import oMarkUrl from "../assets/brand/oathera-o-black.svg?url";
import logoUrl from "../assets/brand/oathera-logo.png";
import controlplaneLogoUrl from "../assets/brand/oathera-controlplane-logo.svg?url";

/** The OATHERA "O" mark (SVG) — login badge + favicon. Same-origin URL emitted by the build. */
export const oMark: string = oMarkUrl;

/** The full OATHERA logo (PNG) — nav/header. Same-origin URL emitted by the build. */
export const logo: string = logoUrl;

/**
 * The multi-color OATHERA control-plane logo (SVG). Used ONLY on the control plane's login brand
 * panel. Rendered in its natural colors (no `brightness(0) invert(1)`). Same-origin URL from the build.
 */
export const controlplaneLogo: string = controlplaneLogoUrl;
